module.exports = __webpack_public_path__ + "static/logo-9094cd31d1c0fd054e2cf52c1995fc29.png";